(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  const targets = '.section-heading,.eternel-promise__heading,.eternel-promise__media,.eternel-promise__features,.eternel-process__heading,.eternel-process__intro,.eternel-process__steps,.sbc-section__heading-block,.eternel-experience__heading,.eternel-experience__cards,.customer-favorites__heading,.eternel-instagram-showcase__heading';
  function reveal(scope = document) {
    if (document.body.dataset.scrollReveal !== 'true' || reduced.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
    document.body.classList.add('tbv-motion');
    observer ||= new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-revealed'); observer.unobserve(entry.target); } }),{threshold:.08});
    scope.querySelectorAll(targets).forEach(el => {if (el.dataset.revealBound) return;el.dataset.revealBound='true';el.classList.add('tbv-reveal');observer.observe(el);});
  }
  function closeMenu(returnFocus = true) {
    const nav = document.querySelector('.main-nav.is-open');
    nav?.classList.remove('is-open');
    document.body.classList.remove('menu-open');
    document.querySelectorAll('[data-menu-toggle]').forEach(el=>el.setAttribute('aria-expanded','false'));
    document.querySelectorAll('[data-menu-inert]').forEach(el=>{el.inert=false;delete el.dataset.menuInert;});
    if (returnFocus && nav) document.querySelector('[data-menu-toggle]')?.focus();
  }
  document.addEventListener('click',e=>{
    const trigger=e.target.closest('[data-menu-toggle]');
    if (trigger && document.body.classList.contains('tbv-editorial')) {
      const open=trigger.getAttribute('aria-expanded')==='true';
      document.body.classList.toggle('menu-open',open);
      document.querySelectorAll('#MainContent,.site-footer,.header-actions,.logo').forEach(el=>{el.inert=open;if(open)el.dataset.menuInert='true';else delete el.dataset.menuInert;});
      if(open)document.querySelector('.main-nav.is-open [data-menu-close]')?.focus();
    }
    if(e.target.closest('[data-menu-close]'))closeMenu();
    const search=e.target.closest('[data-search-open]');
    if(search && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button===0) {
      e.preventDefault(); closeMenu(false);
      const dialog=document.getElementById('TBVSearchDialog');
      if(dialog && !dialog.open) {dialog.showModal();document.body.classList.add('dialog-open');dialog.addEventListener('close',()=>{if(!document.querySelector('dialog[open]'))document.body.classList.remove('dialog-open');search.focus();},{once:true});document.getElementById('TBVSearchInput')?.focus();}
    }
    if(e.target.closest('[data-back-top]'))window.scrollTo({top:0,behavior:reduced.matches?'instant':'smooth'});
  });
  document.addEventListener('keydown',e=>{
    const nav=document.querySelector('.main-nav.is-open');
    if(!nav || !document.body.classList.contains('tbv-editorial'))return;
    if(e.key==='Escape')closeMenu();
    if(e.key==='Tab') {
      const focusable=[...nav.querySelectorAll('a,button,summary,input,select')].filter(el=>!el.disabled && el.getClientRects().length);
      const first=focusable[0],last=focusable.at(-1);
      if(e.shiftKey && document.activeElement===first){e.preventDefault();last?.focus();}
      else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first?.focus();}
    }
  });
  const desktop=matchMedia('(min-width:990px)');desktop.addEventListener('change',()=>closeMenu(false));
  const topButton=document.querySelector('[data-back-top]');
  const syncTop=()=>topButton?.classList.toggle('is-visible',window.scrollY>600);
  window.addEventListener('scroll',syncTop,{passive:true});syncTop();
  reduced.addEventListener('change',()=>{if(reduced.matches){observer?.disconnect();document.querySelectorAll('.tbv-reveal').forEach(el=>el.classList.add('is-revealed'));}else reveal();});
  document.addEventListener('shopify:section:load',e=>reveal(e.target));
  document.addEventListener('shopify:section:unload',()=>closeMenu(false));
  function decorativeVideos(scope = document) {
    scope.querySelectorAll('.eternel-promise video').forEach(video=>{
      if(video.dataset.motionBound)return;
      video.dataset.motionBound='true';
      const button=video.parentElement.querySelector('[data-video-pause]');
      const sync=()=>{button?.setAttribute('aria-label',video.paused?'Play video':'Pause video');button?.setAttribute('aria-pressed',String(video.paused));const label=button?.querySelector('[data-video-label]');if(label)label.textContent=video.paused?'Play':'Pause';};
      const motion=()=>{if(reduced.matches)video.pause();};
      video.addEventListener('play',sync);video.addEventListener('pause',sync);reduced.addEventListener('change',motion);video._tbvCleanup=()=>reduced.removeEventListener('change',motion);motion();sync();
    });
  }
  function newsletter(scope = document) {
    scope.querySelectorAll('[data-newsletter-popup]').forEach(dialog=>{
      if(dialog.dataset.popupBound)return;dialog.dataset.popupBound='true';
      let timer;
      const key='tbv-newsletter-seen';
      const show=()=>{if(document.querySelector('dialog[open]')||document.hidden)return;try{sessionStorage.setItem(key,'true');}catch{}dialog.showModal();document.body.classList.add('dialog-open');};
      dialog.addEventListener('close',()=>{if(!document.querySelector('dialog[open]'))document.body.classList.remove('dialog-open');});
      if(dialog.querySelector('[data-newsletter-result]'))show();
      else if(!window.Shopify?.designMode){let seen=false;try{seen=sessionStorage.getItem(key)==='true';}catch{}if(!seen)timer=setTimeout(show,Number(dialog.dataset.delay)||12000);}
      dialog._tbvCleanup=()=>clearTimeout(timer);
    });
  }
  document.addEventListener('shopify:section:load',e=>{decorativeVideos(e.target);newsletter(e.target);});
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-newsletter-popup]').forEach(d=>{d._tbvCleanup?.();if(d.open)d.close();}));
  decorativeVideos(); newsletter(); reveal();
})();
